import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../components/elements/Card';
import DataTable from '../../components/elements/DataTable';
import ErrorHandler from '../../components/elements/ErrorHandler';
import ScrollToTop from '../../components/elements/ScrollToTop';
import Text from '../../components/fields/Text';
import MerchantNotOnboardFilter from '../../components/fragments/MerchantNotOnboardFilter/';
import { AppContext } from '../../contexts';
import { thousand } from '../../utils/format';
import { useDebounce } from '../../utils/hooks';
import {
  fetchMerchantNotOnboardList
} from './actions';
import styles from './styles.scoped.css';


function MerchantNotOnboard() {
  const { setBreadcrumbs } = useContext(AppContext);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const {
    table: { data, meta, loading, filter = null, message },
  } = useSelector((state) => state.merchantNotOnboard);
  const {
    dataDetailUser: { regionalId },
  } = useSelector((state) => state.pageBase);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 1000);

  const fetchMerchantRegistrationData = (page = 1, initial = true) => {
    dispatch(
      fetchMerchantNotOnboardList({ nextPage: page, search, filter, initial })
    );
  };

  const column = [
    {
      heading: 'Tanggal Registrasi',
      value: 'registrationDate',
    },
    {
      heading: 'ID Pangkalan',
      value: 'registrationId',
    },
    {
      heading: 'MID',
      value: 'midMap',
      className: '',
    },
    { heading: 'Nama Pangkalan LPG 3 Kg', value: 'storeName', className: '' },
  ];

  useEffect(() => {
    if (filter && filter.regional.length > 0 || !regionalId) {
      fetchMerchantRegistrationData();
    }
  }, [filter, debouncedSearch]);

  useEffect(() => {
    setBreadcrumbs(['Data Pangkalan LPG 3 Kg Belum Onboarding']);
  }, []);

  if (message) {
    return <ErrorHandler message={message} />;
  }

  return (
    <main className={styles.root}>
      <MerchantNotOnboardFilter />
      <Card className={styles['table-filter-container']}>
        <p>
          Menampilkan <strong>{thousand(meta.totalData)}</strong> data
        </p>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              disabled={loading}
              hideLabel
              inputProps={{
                ref: inputRef,
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) =>  {
                  setSearch(e.target.value);
                }
              }}
            />
          </div>
        </div>
      </Card>
      <Card className={styles.table}>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={500}
            loading={loading}
            meta={meta}
            onEndReached={() => {
              !loading && fetchMerchantRegistrationData(meta.page + 1, false);
            }
            }
            onRefresh={fetchMerchantRegistrationData}
            withIndex
          />
        </div>
      </Card>
      <ScrollToTop />
    </main>
  );
}

export default MerchantNotOnboard;
